/**
 * useButtonMenu
 *
 * Owns the "button menu" open/close state that was previously class state
 * on FormViewer:
 *
 *   openButtonMenu()   — set menuButtonOpen: true
 *   closeButtonMenu()  — set menuButtonOpen: false
 *
 * State returned for render:
 *   menuButtonOpen — boolean
 */
import { useState, useCallback } from 'react';

const useButtonMenu = () => {
  const [menuButtonOpen, setMenuButtonOpen] = useState(false);

  const openButtonMenu = useCallback(() => setMenuButtonOpen(true), []);
  const closeButtonMenu = useCallback(() => setMenuButtonOpen(false), []);

  return { menuButtonOpen, openButtonMenu, closeButtonMenu };
};

export default useButtonMenu;
